export default __webpack_public_path__ + "static/media/utmc.923fadf3.png";